import { render } from "./TestCaseValidationComparisonTable.vue?vue&type=template&id=724cfda2&scoped=true"
import script from "./TestCaseValidationComparisonTable.vue?vue&type=script&lang=js"
export * from "./TestCaseValidationComparisonTable.vue?vue&type=script&lang=js"

import "./TestCaseValidationComparisonTable.vue?vue&type=style&index=0&id=724cfda2&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724cfda2"]])

export default __exports__
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanel,QTab,QTabPanels,QTable});
